import React from "react";
import {FaLink, FaUnlink} from "react-icons/fa";
import { colors } from "../../utils/Utils";

const LinkUnlink = ({checked, label, onClick, disabled=false, style={}}) => {

	return (
		<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', ...style}} disabled={disabled} onClick={disabled ? ()=>null: onClick}>
				{checked ? (
					<FaLink style={{ cursor: (disabled ? 'auto' : 'pointer'), color:(disabled ? 'gray' : colors.primary), marginRight: 4 }} />
				) : (
					<FaUnlink style={{ cursor: (disabled ? 'auto' : 'pointer'), color:(disabled ? 'gray' : colors.primary), marginRight: 4 }} />
				)}
        <span style={{color: (disabled ? 'gray' : 'black'), paddingLeft: 4, verticalAlign: 'middle'}}>{label}</span>
		</div>
	)
}
export default LinkUnlink;